<template>
    <div class="warpper padding-sm">
        <div class="flex align-center justify-between margin-bottom-sm list-title">
            <b> 邮箱管理</b>
           <div class="flex align-center">
                <span class="add-btn" @click="addEmailDialog = true">邮箱添加
            </span>
               <el-button class="blue-btn margin-left-xs" round @click="$router.go(-1)">返回</el-button>
           </div>
        </div>
        <div class="ship-list">
            <el-table :data="lists" header-row-class-name="table-header"
                      border
                      style="width: 100%; border-radius: 10px">
                <el-table-column label="邮箱" prop="name">
                    <template slot-scope="scope">
                       <div class="flex justify-center"> {{scope.row.email}}</div>
                    </template>
                </el-table-column>
                <el-table-column label="smtp授权码" prop="price">
                    <template slot-scope="scope">
                        <div class="flex justify-center">{{scope.row.code}}</div>
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <div class="flex justify-center">
                        <el-button @click="editItem(scope.row)" class="blue-btn"  round size="small">编辑</el-button>
                        <span class="padding-lr-sm" v-if="scope.$index>2"></span>
                        <el-button @click="delItem(scope.row.id)" class="line-btn" round size="small" v-if="scope.$index>2">删除</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <add-email-dialog
            :setItem="setItem"
            :dialog="addEmailDialog"
            @cancelDialog="cancelDialog"
        />
    </div>
</template>

<script>
import {getEmailList, delEmail} from "@/api/organiz";
import AddEmailDialog from "@/views/organization/page/email/addEmailDialog";

export default {
    name: "setting",
    data() {
        return {
            lists: [],
            limit:10,
            page:1,
            setItem:null,
            addEmailDialog:false
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        }
    },
    created() {
        this.$emit('setIndex', [1, 3], '邮箱设置')
        this.getEmailList()
    },
    components: {AddEmailDialog},
    methods: {
        //  关闭编辑框
        cancelDialog(val){
            this.setItem = null
            this.addEmailDialog = false
            if(val){
                this.getEmailList()
            }
        },
        //  编辑
        editItem(obj){
            this.setItem = obj
            this.addEmailDialog = true
        },
        //    删除级别
        delItem(id) {
            this.$confirm('此操作将删除该级别, 是否继续?', '温馨提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.sureDelete(id)
            })
        },
        async sureDelete(id) {
            let _state = await delEmail(id)
            if (_state.status === 200) this.$message.success(_state.msg), this.getEmailList()
        },
        //  获取等级列表
        async getEmailList() {
            let _list = await getEmailList(this.page,this.limit)
            this.lists = _list.data
        }
    },
    filters: {},
    watch: {},
}
</script>

<style scoped lang="scss">
.warpper {
    background: #fff;
    border-radius: 10px;
    .classifys {
        margin-bottom: 20px;
        .classify {
            width: 120px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            border: 1px solid #ffb400;
            color: #ffb400;
            border-radius: 0 6px 6px 0;

            &.active {
                background: #ffb400;
                color: #FFFFFF;
                border-radius: 6px 0  0 6px;
            }
        }
    }
    .list-title {
        b {
            font-size: 26px;
            line-height: 34px;
        }

        .add-btn {
            display: block;
            width: 200px;
            height: 40px;
            text-align: center;
            line-height: 40px;
            background-image: linear-gradient(37deg, #ffb400 0%, #fc7802 100%),
            linear-gradient(#0a2240, #0a2240);
            background-blend-mode: normal, normal;
            border-radius: 20px;
            font-size: 16px;
            color: #fff;
            cursor: pointer;
        }
    }
}
</style>